import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ReferenceField, ShowBase, TextField, useRecordContext } from "react-admin";
import ComponentShow, { ShowActions } from "../../../components/PageComponents/ComponentShow";
import DetailHeader from "../../../components/PageComponents/DetailHeader";
import { StatusLabel } from "../../../components/Label/status";
import { formatDateTime } from "../../../utils/paymentFormat";
import RecentActivity from "./RecentActivity";
import ProjectDetails from "./ProjectDetails";
import { FETCH_ENTITY, projectTypeLabel } from "./projectFields";

const Content = () => {
  const { t }: { t: any } = useTranslation();
  const record = useRecordContext();
  if (!record) return null;
  return (
    <ComponentShow
      header={
        <Box display="flex" flexWrap="wrap" justifyContent="space-between" alignItems="flex-start" gap={2}>
          <DetailHeader
            kind="Entity"
            title={record.name}
            status={<StatusLabel statusField="status" />}
            facts={[
              record.typeProject && t(projectTypeLabel(record.typeProject)),
              record.accountId && (
                <ReferenceField source="accountId" reference="accounts" link={false}>
                  <TextField source="name" variant="body2" color="text.secondary" />
                </ReferenceField>
              ),
              formatDateTime(record.dateCreated),
            ]}
          />
          <ShowActions resource="projects" />
        </Box>
      }
    >
      <Box sx={{ px: { xs: 3, md: 5 }, pb: 2 }}>
        <RecentActivity />
        <ProjectDetails />
      </Box>
    </ComponentShow>
  );
};

const ProjectShow = () => (
  <ShowBase queryOptions={FETCH_ENTITY}>
    <Content />
  </ShowBase>
);

export default ProjectShow;
